import * as THREE from "three";
import GameConfig from "../config";
import meshCloner from "../utils/meshCloner";
import config from "../config";
import GLTFCloner from "../utils/gltfCloner";
import MeshUtils from "../utils/meshUtils";

export default class Gate {
    constructor({scene, blueprints, position = new THREE.Vector3()}) {
        this.scene = scene;
        this.blueprints = blueprints;
        this.boundingBox = this.createBoundingBox();
        this.scene.add(this.boundingBox);

        this.mesh = new THREE.Group();
        this.meshWeb = meshCloner(this.blueprints[0], true);
        this.meshWeb.material.needsUpdate = true;
        this.meshWeb.material.uniformsNeedUpdate = true;
        this.meshWeb.scale.set(2,2,2);
        this.meshWeb.position.set(0,3,1)

        this.mesh.add(this.meshWeb);

        this.meshTreeRight = meshCloner(this.blueprints[1]);
        this.meshTreeRight.position.set(-6,0, 0);
        this.meshTreeRight.rotation.x = -Math.PI / 2;

        this.meshTreeLeft = meshCloner(this.blueprints[1]);
        this.meshTreeLeft.position.set(6,0, 0);
        this.meshTreeLeft.rotation.x = -Math.PI / 2;

        this.meshTreeTop = meshCloner(this.blueprints[1]);
        this.meshTreeTop.position.set(8,7, 0);
        this.meshTreeTop.rotation.x = -Math.PI / 2;
        this.meshTreeTop.rotation.y = -Math.PI / 2;
        this.meshTreeTop.rotation.z = -Math.PI;
        this.meshTreeTop.scale.set(0.5,0.5,2);

        this.gateBow = MeshUtils.mergeMeshes([
            this.meshTreeTop,
            this.meshTreeRight,
            this.meshTreeLeft
        ])

        this.mesh.add(this.gateBow);

        this.scene.add(this.mesh);
        this.moveTo(position);
    }

    createBoundingBox(){
        const dim = 1
        const geometry = new THREE.BoxGeometry( dim * 6, dim * 10, dim * config.GENERAL.SKILL_GATE_DEPTH);
        const material = new THREE.MeshStandardMaterial( {color: 0xffff00} );

        const bb = new THREE.Mesh( geometry, material );

        bb.geometry.computeBoundingBox();
        bb.updateMatrixWorld(true);

        bb.visible = false;

        bb.material.transparent = true;
        bb.material.opacity = 0.2;

        if(GameConfig.DEBUG.ON && GameConfig.DEBUG.PHYSICS){
            bb.visible = true;
        }

        if(GameConfig.DEBUG.ON && GameConfig.DEBUG.PHYSICS){
            bb.visible = true;
        }

        return bb;
    }

    moveTo(position){
        if(this.boundingBox) this.boundingBox.position.copy(position);
        this.mesh.position.copy(position);
        this.mesh.position.z += 3.5;
    }

    destroy(){
        this.mesh.traverse((e) => {
            if(e.geometry) e.geometry.dispose();
        })
        this.scene.remove(this.mesh);

        this.boundingBox.geometry.dispose();
        this.scene.remove(this.boundingBox);
    }
}